import React, { useEffect, useState } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import GraphQLAPI, { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { getProduct } from "../graphql/queries";
import carData from "../assets/data/carData.ts";
import { Container, Row, Col } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import { useParams } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";

const getProductsLinks = [{}];


const images = []

// console.log(images)

const ProductDetails = () => {
  const { slug } = useParams();

  const location = useLocation();
 // console.log(location.pathname);
  // console.log(slug, "slug");

  const [getProductDetails, setgetProductCat] = useState(getProductsLinks)
  const [productDimensions, setgetProductDimension] = useState(getProductsLinks)
  const [productImage, setproductImage] = useState(images)

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchGetProduct();

  },[]);

  const fetchGetProduct = async ()=> {

    try {
     // console.log(slug, "inside fetch")
      const getProductCatData = await API.graphql(graphqlOperation(getProduct,
          { slug: slug },
          {authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS}));

       //   console.log(getProductCatData, "getProductCatData")

      const _productCategoriesList = getProductCatData?.data?.getProduct

        // console.log(_productCategoriesList.images, "slider -cffff")
         setproductImage(_productCategoriesList.images)
      setgetProductCat(_productCategoriesList)
      setgetProductDimension(_productCategoriesList?.dimension)
    } catch (err) { console.log(err, 'error get product details') }
  }


  const settings = {
    fade: true,
    speed: 2000,
    autoplaySpeed: 3000,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
  };

  return (
    <Helmet 
       title={getProductDetails?.title} >
      <section className="product__detail">
     
        <Container>
          <div className="product_breadcrumb">
        <Link
          to={"/"}
          >
          Home /
        </Link>
        <Link
          to={`/product-category/${getProductDetails?.category}`}
         >
           {getProductDetails?.category} / 
        </Link>
        <Link
          to={`/product/${getProductDetails?.title}`}
        >
           {getProductDetails?.title}
        </Link>
        </div>
          <Row>
            <Col lg="6">
              {/* <Slider {...settings} className="slider__item">
                <img src={productImages} alt="Images" />
              </Slider> */}
              <div className="ImageThumb">
                <ImageGallery  
                autoPlay={true}
                infinite={true}
                  items={productImage}
                  // height="100px"
                />
              </div>
            </Col>

            <Col lg="6">
              <div className="car__info">
                <h2 className="section__title">{getProductDetails.title}</h2>

                {/* <div className=" d-flex align-items-center gap-5 mb-4 mt-3">
                  <h6 className="rent__price fw-bold fs-4">
                    {getProductDetails?.description}
                  </h6>
                </div> */}
                  <h6>Application Area:</h6>
                  <p className="section__description">
                    CounterTops, Stairs, Window sills, Wall, Floor
                  </p>

               
                  <h6>Available Sizes:</h6>
                  <div className="available_sizes section__description">
                    <ul>
                      <li>CounterTops - Custom sizes</li>
                      <li>Cutter Slabs - 240up x 60up in 2 & 3 cm</li>
                      <li>Gangsaw slabs -  280up x 160up in 2 & 3 cm</li>
                      <li>Tiles - 30 x 30, 30 x 60 cm</li>
                    </ul>
                  </div>
                  <h6>Available sizes:</h6>
                  <p className="section__description">Flamed, Polished, Honed</p>
                  {/* <div className="available_sizes">
                    <ul>
                      <li>Flamed</li>
                      <li>Polished</li>
                     <li>Honed</li>
                    </ul>
                  </div> */}
                  <h6>Edge Finishes:</h6>
                  <p className="section__description">
                    Machine cut edges
                  </p>

                 
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default ProductDetails;
